import { Component, OnInit, Input } from '@angular/core';
import { ModelCommonContainer } from './model';

@Component({
  selector: "app-common-container",
  templateUrl: "./common-container.component.html",
  styleUrls: ["./common-container.component.scss"]
})
export class CommonContainerComponent implements OnInit {
  _mModel: ModelCommonContainer;
  @Input("model") set val(value: ModelCommonContainer) {
    if (value) {
      this._mModel = value;
    }
  }

  constructor() {}

  ngOnInit() {}
}
